import { useTranslation } from 'react-i18next';

import { ListingCard } from './listing-card';
import { formatDuration, formatPrice, formatRating, localePath } from '../lib/format';
import { localizedTourTitle } from '@todo/core/i18n/tour-content';
import { useLocale } from '@todo/core/i18n/use-locale';
import { sizedTourImage, type Tour } from '@todo/core/tours';

export function TourCard({ tour, featured }: { tour: Tour; featured?: boolean }) {
  const { t } = useTranslation();
  const { locale } = useLocale();

  const facts: string[] = [];
  if (tour.rating != null && tour.review_count) {
    facts.push(`★ ${formatRating(tour.rating, locale)} (${t('card.reviews', { count: tour.review_count })})`);
  }
  if (tour.duration) facts.push(formatDuration(tour.duration, locale));

  return (
    <ListingCard
      href={localePath(locale, `tours/${tour.id}`)}
      // Phones get 480x320 even in the featured row (a 674x446 there was
      // most of the home page's image bytes in Lighthouse's mobile LCP).
      imageUrl={sizedTourImage(tour.image_url, 480, 320)}
      imageDesktopUrl={featured ? sizedTourImage(tour.image_url, 674, 446) : null}
      // A Click&Boat trip is a boat trip — the strip's "Yachts & Cruises".
      category={tour.source === 'click_and_boat' ? t('card.boat') : t('card.tour')}
      title={localizedTourTitle(tour, locale)}
      facts={facts}
      price={
        tour.from_price != null
          ? t('card.from', { price: formatPrice(Number(tour.from_price), tour.currency, locale) })
          : null
      }
    />
  );
}
